'use strict';

var initReportGeneration = require('./initReportGeneration');

const url = $('#dashboard-site>h1>a').data('url');
const competitors = $('#dashboard-competitors .url').map((i, elm) => $(elm).text()).toArray();
const isInside = $('#dashboard-content').hasClass('inside-page');

window.isInsideReview = isInside;
window.currentWebsite = url;

initReportGeneration({
  url,
  competitors,
  isInside
});
